.rightExtraGroup {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
}

.viewToggle {
	display: inline-flex;
	align-items: center;
	background: #f3f4f6;
	border: 1px solid #e5e7eb;
	border-radius: 0.6rem;
	padding: 0.2rem;
	gap: 0.2rem;
	margin: 0;
	min-width: 0;
}

.viewToggleButton {
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	padding: 0.35rem 0.7rem;
	font-size: 0.78rem;
	font-weight: 600;
	color: #4b5563;
	background: transparent;
	border: none;
	border-radius: 0.45rem;
	cursor: pointer;
	transition:
		background 0.15s ease,
		color 0.15s ease;
}

.viewToggleButton:hover {
	color: #111827;
}

.viewToggleButtonActive {
	background: #ffffff;
	color: #111827;
	box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

@media (max-width: 640px) {
	.viewToggleButton span {
		display: none;
	}
	.viewToggleButton {
		padding: 0.4rem 0.5rem;
	}
}
